import { graphql, QueryProps } from 'react-apollo'
import gql from 'graphql-tag'

export type CountryType = {
  id: string
  displayName: string
}

const COUNTRIES_QUERY = gql`
  query CountriesQuery {
    countries {
      id
      displayName
    }
  }
`

type Response = {
  countries: CountryType[]
}

type InputProps = {}

type ApolloProps = Response & QueryProps

export const withCountries = graphql<Response, InputProps, ApolloProps>(
  COUNTRIES_QUERY,
  {
    props: ({ data }) => ({ ...data })
  }
)



// WEBPACK FOOTER //
// ./src/Components/Shared/CountryOptions.tsx